import * as React from 'react';
import { MaskedTextBoxComponent } from '@syncfusion/ej2-react-inputs';
import './OpMaskedInput.css';

export const OpMaskedInput = (props) => {
  const {
    mask = '00:00',
    width = '100%',
    placeholder = '00:00',
    ...rest
  } = props;

  const maskedInputRef = React.useRef(null);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      // Trigger the onBlur event manually
      if (maskedInputRef.current) {
        // Trigger the blur event
        if (typeof props.onBlur === 'function') props.onBlur({target: { value: event.target.value }});
      }
    }
  };

  return (
    <div id='form-element-op-masked-input' style={{ width }}>
      <MaskedTextBoxComponent
        ref={maskedInputRef}
        cssClass='op-masked-input'
        mask={mask}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        {...rest}
      ></MaskedTextBoxComponent>
    </div>
  );
};